var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-steps',_vm._b({attrs:{"items":_setup.items}},'a-steps',_vm.$attrs,false),_vm._l((_setup.items),function(item){return _c('a-step',{key:item.title,scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(item.title))]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }